import React from "react";
import { Link } from "react-router-dom";
import "./footer.scss";
import { socialIcon, terms } from "../../assets/data";

const Footer = () => {
	return (
		<footer>
			<div className="container">
				<hr />
				<div className="footer__container">
					<Link to="/" className="logo">
						<h1>
							M<span>II</span>TA
						</h1>
					</Link>
					<ul className="terms">
						{terms.map(({ id, text }) => {
							return <li key={id}>{text}</li>;
						})}
					</ul>
					<div className="socials__container">
						<p className="mail">hello@miita.co</p>
						<div className="footer__socials">
							{socialIcon.map(({ id, icon, link }) => {
								return (
									<a
										key={id}
										href={link}
										target="_blank"
										rel="noreferrer noopener"
									>
										{icon}
									</a>
								);
							})}
						</div>
						<p>&copy; 2020 MIITA. All Rights Reserved</p>
					</div>
					<p className="footer__end">
						We have calculated <span>120,457,357 appliances</span> for different
						buildings
					</p>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
